import { Badge } from "@/components/ui/badge";
import { getStatusDotColor, getStatusLabel } from "@/lib/api";

export const StatusBadge = ({ status, compact = false }) => {
  const dotColor = getStatusDotColor(status);
  const label = getStatusLabel(status);

  if (compact) {
    return (
      <div className="flex items-center gap-1.5">
        <span 
          className="w-2 h-2 rounded-full" 
          style={{ backgroundColor: dotColor }}
        />
        <span className="font-mono text-xs uppercase tracking-wide">
          {status.replace("_", " ")}
        </span>
      </div>
    );
  }

  return (
    <Badge 
      variant="outline" 
      className="font-mono text-xs uppercase tracking-wide border-border"
    >
      <span 
        className="w-2 h-2 rounded-full mr-2" 
        style={{ backgroundColor: dotColor }}
      />
      {label}
    </Badge>
  );
};
